module.exports = __webpack_public_path__ + "static/media/work_img2.84099b87.jpg";